<div class="flex flex-col h-full">
  <router-outlet></router-outlet>
</div>
